module.exports = __webpack_public_path__ + "static/media/easycontent-logo@2x.34a86bc4.png";